import React, { Suspense, lazy } from 'react';
import { withRouter } from 'react-router-dom';

const ImageLoader = lazy(() => import('../../common/image-loader'));

class PageConnectionError extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            _props: this.props.data,

            /** test - delete */
            _props: { title: '404', heading: 'Page Not Found', subtitle: 'It looks like nothing was found at this location.', linkText: 'BACK TO HOME', linkURL: `/` }

            /* _props: { title: '404', heading: 'Page Not Found', subtitle: 'It looks like nothing was found at this location. Try another link or click the button below.', linkText: 'BACK TO HOME', linkURL: `/` } */
            /** test */
        }
    }

    componentDidMount() {
        
    }

    render() {
        return (
            <div className="page-error">
                <div className='c-logo'>
                    <Suspense fallback={null}>
                        <ImageLoader type="image" src="/logo-big.png"></ImageLoader>
                    </Suspense>
                </div>
                <div className='error-body page-not-found'>
                    <div className='mask'></div>
                    {/* <Suspense fallback={null}>
                        <ImageLoader type="image" src="/images/banner/mosk.png"></ImageLoader>
                    </Suspense> */}
                    <div className="c-error">
                        <h3 className='fof'>{this.state._props.title}</h3>
                        <h4>{this.state._props.heading}</h4>
                        <p>{this.state._props.subtitle}</p>
                        {/* <button type="button" className="btn btn-light">{this.state._props.linkText}</button> */}
                    </div>
                </div>
                {/* <Footer/> */}
            </div>
        )
    }
}

export default withRouter(PageConnectionError);